import type { IMatchOfficial } from './matchesDetails/types/matchDetails.d';
import type { IDivisionResponse } from '../../../../myTeam/types/myTeam';

export type ScheduleGroundOption = { groundId: string; groundName: string };

export function officialScheduleId(o?: IMatchOfficial | null): string {
  if (!o) return '';
  const ext = o as Record<string, unknown>;
  return String(o.id ?? ext.playerId ?? ext.umpireId ?? ext.scorerId ?? '').trim();
}

export function localDateAndTimeFromIso(iso: string): { date: string; time: string } {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return { date: '', time: '' };
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return { date: `${y}-${m}-${day}`, time: `${hh}:${mm}` };
}

export function resolveDivisionSelectionFromApi(
  apiDivisionId: string,
  divisions: IDivisionResponse[],
): { divisionId: string; groupId: string } | null {
  const id = apiDivisionId.trim();
  if (!id) return null;
  const asParent = divisions.find((d) => d.divisionId === id);
  if (asParent) {
    const children = asParent.childDivisions ?? [];
    if (children.length === 0) return { divisionId: id, groupId: '' };
    return null;
  }
  for (const d of divisions) {
    const hit = (d.childDivisions ?? []).find((g) => g.divisionId === id);
    if (hit) return { divisionId: d.divisionId, groupId: hit.divisionId };
  }
  return null;
}

export function extractGroundIdForSchedule(
  ground: unknown,
  groundsList: ScheduleGroundOption[],
): string {
  if (ground == null) return '';
  if (typeof ground === 'string') {
    return ground.trim();
  }
  if (typeof ground === 'object') {
    const g = ground as Record<string, unknown>;
    const id = g.groundId;
    if (typeof id === 'string' && id.trim()) return id.trim();
    const name = typeof g.groundName === 'string' ? g.groundName.trim() : '';
    if (name) {
      const found = groundsList.find((x) => x.groundName.trim() === name);
      if (found) return found.groundId;
    }
  }
  return '';
}
